import { useLocation, useNavigate } from "react-router-dom";

import Switcher from "common/components/ui/Switcher";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function PlanInvoicesToggle({
  planLabel,
}: {
  planLabel: string;
}) {
  const isDesktop = useTwBreakpoint("lg");
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const options = [
    { value: "", label: planLabel },
    { value: "invoices", label: "Invoices" },
  ];

  return (
    <Switcher
      options={options}
      selectedOption={pathname.includes("invoices") ? "invoices" : ""}
      onOptionSelect={(newValue) => {
        navigate(newValue);
      }}
      className="max-lg:flex-1"
      size={isDesktop ? "xs" : "md"}
    />
  );
}
